import { render, staticRenderFns } from "./yearly-input-field-header.vue?vue&type=template&id=64af2fbf&scoped=true"
import script from "./yearly-input-field-header.vue?vue&type=script&lang=js"
export * from "./yearly-input-field-header.vue?vue&type=script&lang=js"
import style0 from "./yearly-input-field-header.vue?vue&type=style&index=0&id=64af2fbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af2fbf",
  null
  
)

export default component.exports